import { render } from "./AppleLoginMessageModal.vue?vue&type=template&id=919fd232&scoped=true"
import script from "./AppleLoginMessageModal.vue?vue&type=script&lang=js"
export * from "./AppleLoginMessageModal.vue?vue&type=script&lang=js"

import "./AppleLoginMessageModal.vue?vue&type=style&index=0&id=919fd232&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-919fd232"

export default script